import { render, staticRenderFns } from "./MarginCalculate.vue?vue&type=template&id=cfb6cd50"
import script from "./MarginCalculate.vue?vue&type=script&lang=js"
export * from "./MarginCalculate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports